import { QuotePlanSchema } from '../../../server/map-quotes';

export const filterWithPlanType = (selectedPlanType: number, filteredQuotes: QuotePlanSchema[]) => {
	return selectedPlanType
		? filteredQuotes.filter((quote) => quote.planTypeIds.includes(selectedPlanType))
		: filteredQuotes;
};
